<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="产品CODE" prop="productCode">
          <el-input v-model="dataForm.productCode" placeholder="产品CODE"></el-input>
      </el-form-item>
          <el-form-item label="产品名称" prop="productName">
          <el-input v-model="dataForm.productName" placeholder="产品名称"></el-input>
      </el-form-item>
          <el-form-item label="产品CODE" prop="stepCode">
          <el-input v-model="dataForm.stepCode" placeholder="产品CODE"></el-input>
      </el-form-item>
          <el-form-item label="产品CODE" prop="stepName">
          <el-input v-model="dataForm.stepName" placeholder="产品CODE"></el-input>
      </el-form-item>
              <!-- <el-form-item label="更新人" prop="updateBy">
          <el-input v-model="dataForm.updateBy" placeholder="更新人"></el-input>
      </el-form-item>
          <el-form-item label="更新日期" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="更新日期"></el-input>
      </el-form-item>
          <el-form-item label="删除日期" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除日期"></el-input>
      </el-form-item> -->
          <el-form-item label="状态（1已上架、0未上架）" prop="status">
          <el-input v-model="dataForm.status" placeholder="状态（1已上架、0未上架）"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        productCode: '',
        productName: '',
        stepCode: '',
        stepName: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: '',
        deleteTime: '',
        status: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        productCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        stepCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        stepName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/slproductapplystep/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/slproductapplystep/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
